import { render, staticRenderFns } from "./FilialsIndicatorsList.vue?vue&type=template&id=8b12d03a&scoped=true&"
import script from "./FilialsIndicatorsList.vue?vue&type=script&lang=js&"
export * from "./FilialsIndicatorsList.vue?vue&type=script&lang=js&"
import style0 from "./FilialsIndicatorsList.vue?vue&type=style&index=0&id=8b12d03a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b12d03a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
